import { loadRemoteModule } from '@cw-elements/mfe-setup/load';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Button, ButtonType } from 'syngenta-digital-cropwise-react-ui-kit';
import './styles.less';

interface ConnectFilesProps {
  userLanguage: string;
  orgId: string;
  isOpen: boolean;
  onClose: () => void;
}

interface ConnectFilesWrapperProps {
  orgId: string;
}

export const ConnectFiles: React.FC<ConnectFilesWrapperProps> = ({ orgId }) => {
  const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);

  const ConnectFilesComponent = React.useMemo(
    () =>
      React.lazy<React.FC<ConnectFilesProps>>(() =>
        loadRemoteModule('connect-files/connect-files'),
      ),
    [],
  );

  return (
    <div className="gap-8 flex flex-col items-center justify-center">
      <Button type={ButtonType.primary} onClick={() => setIsModalOpen(true)}>
        Open Connect files
      </Button>
      <ErrorBoundary fallback={<span />}>
        <React.Suspense fallback={<span />}>
          <ConnectFilesComponent
            userLanguage="en"
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            orgId={orgId}
          />
        </React.Suspense>
      </ErrorBoundary>
    </div>
  );
};
